import { createContext } from '@backyard-ui/utils';
import { createStore, type StoreApi } from 'zustand';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn } from 'zustand/traditional';

export interface GlobalState {
  /**
   * Settings from server-side, eg:
   * user-agent, ip address, etc
   */
  server: {
    /**
     * Get device type via user agent
     */
    device: 'desktop' | 'mobile';

    /**
     * Detect mobile via query string or user-agent, eg:
     * http://localhost:3000/?isOnMobileApp=true
     * Remove header and footer on APP
     */
    isOnMobileApp?: boolean;
  };

  session: {
    region: string;
    cartId?: string;
    regionName?: string;
    locationSource?: 'user' | 'cloudflare';
    zipCode?: string;
  };
}

export interface GlobalActions extends GlobalState {}

const createGlobalStore = (initialState: GlobalState) =>
  createStore<GlobalActions>()((set) => ({
    ...initialState,
  }));

const { Provider: GlobalProvider, useContext: useGlobalContext } =
  createContext<StoreApi<GlobalState>>({
    name: '@store/Global',
  });

const useGlobalStore = <T>(
  selector: (state: GlobalActions) => T,
  equalityFn: (a: any, b: any) => boolean = shallow
) => {
  const context = useGlobalContext();

  return useStoreWithEqualityFn(
    context as StoreApi<GlobalActions>,
    selector,
    equalityFn
  );
};

export { GlobalProvider, createGlobalStore, useGlobalStore };
